var _defs, _rect, _g, _g2, _path, _g3, _path2, _rect2, _rect3, _rect4, _g4, _rect5, _g5, _tspan, _rect6, _g6, _tspan2, _tspan3, _tspan4, _rect7, _rect8, _mask, _path3, _tspan5, _tspan6, _mask2, _path4, _tspan7, _tspan8, _mask3, _path5, _tspan9, _tspan0, _tspan1, _tspan10, _rect9, _rect0, _tspan11, _tspan12, _tspan13, _g7, _tspan14, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 312,
    viewBox: "0 0 472 312",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 312,
    rx: 24
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_11512_2147_f5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_11512_2147_f5",
    transform: "matrix(0.00105808 0 0 0.00120863 -0.255234 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image2_11512_2147_f5",
    "data-name": "focused-couple-using-tablet-pc_74855-4217-Photoroom(edit).png",
    width: 1280,
    height: 853,
    preserveAspectRatio: "none",
    href: "/feature-art-image2.jpg"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_i_11512_2147_f5",
    x: 205,
    y: 3229,
    width: 474,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.29293 0 0 0 0 0.353365 0 0 0 0 0.257379 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11512_2147"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_11512_2147_f5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_11512_2147_f5",
    transform: "matrix(0.000416667 0 0 0.000626263 0 -0.0010101)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_11512_2147_f5",
    x: 489.7,
    y: 3345.7,
    width: 349.6,
    height: 349.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_11512_2147_f5",
    x: 203.5,
    y: 3242.5,
    width: 499,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 3231,
    width: 472,
    height: 312,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_11512_2147_f5",
    x: 134.7,
    y: 3101.7,
    width: 288.6,
    height: 288.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image1_11512_2147_f5",
    "data-name": "image(edit).png",
    width: 2400,
    height: 1600,
    preserveAspectRatio: "none",
    href: "/feature-art-image1.jpg"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.79807,
    height: 7.79807,
    fill: "white",
    transform: "translate(276.152 3279.9)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_11512_2147_f5",
    x: 207,
    y: 3166,
    width: 218,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_11512_2147_f5",
    x: 249,
    y: 3218,
    width: 134,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 3228,
    width: 114,
    height: 168,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 3228,
    width: 114,
    height: 168,
    rx: 14.5433,
    fill: "white"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_11512_2147_f5",
    x: 182.671,
    y: 3143.72,
    width: 152.345,
    height: 152.345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7038,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_11512_2147_f5",
    x: 278.553,
    y: 3243.23,
    width: 186.205,
    height: 186.206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7038,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.95667,
    height: 7.95667,
    fill: "white",
    transform: "translate(316.861 3279.82)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11512_2147_f5",
    x1: 361.335,
    y1: 3453.01,
    x2: 361.335,
    y2: 3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35CE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6F18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_11512_2147_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 134,
    fill: "white",
    transform: "translate(259 3180)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 782_5_f5",
    filter: "url(#filter51_i_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_11512_2147_f5)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 3231,
    width: 472,
    height: 312,
    rx: 24,
    fill: "#17270D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_6_f5",
    opacity: 0.38,
    filter: "url(#filter52_f_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 3246,
    r: 53,
    fill: "#4CBC18"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_5_f5",
    opacity: 0.24,
    filter: "url(#filter53_f_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 664.5,
    cy: 3520.5,
    r: 83.5,
    fill: "#4CBC18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask group_f5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11512_2147_f5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 3259,
    width: 448,
    height: 284
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 413_f5",
    d: "M231 3269C231 3263.48 235.477 3259 241 3259H679V3543H231V3269Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image 39_f5",
    filter: "url(#filter54_f_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 3244H701V3574H205V3244Z",
    fill: "url(#pattern3_11512_2147_f5)"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "focused-couple-using-tablet-pc_74855-4217-Photoroom 1_f5",
    d: "M305 3244C305 3230.75 315.745 3220 329 3220H650C663.255 3220 674 3230.75 674 3244V3543H305V3244Z",
    fill: "url(#pattern4_11512_2147_f5)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32_f5",
    filter: "url(#filter55_d_11512_2147_f5)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 3206,
    width: 138,
    height: 200,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 3206.25,
    width: 137.5,
    height: 199.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27_4_f5",
    filter: "url(#filter56_d_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "live-link-arv-360_f5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_11512_2147_f5)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 3228,
    width: 114,
    height: 168,
    rx: 14.5433,
    fill: "#F4FAEF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 391_f5",
    clipPath: "url(#clip22_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 134,
    transform: "translate(259 3180)",
    fill: "#17270D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_2_f5",
    opacity: 0.22,
    filter: "url(#filter57_f_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 258.843,
    cy: 3219.89,
    r: 38.7651,
    fill: "#4CBC18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_6_f5",
    opacity: 0.23,
    filter: "url(#filter58_f_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 371.656,
    cy: 3336.33,
    r: 55.6952,
    fill: "#4CBC18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 562_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_5_f5"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 3276.25,
    width: 37.5,
    height: 15.0949,
    rx: 7.54747,
    stroke: "#516842",
    strokeWidth: 0.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Frame_2_f5",
    clipPath: "url(#clip23_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5_f5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19_f5",
    d: "M283.401 3281.42C283.401 3282.09 282.855 3282.64 282.183 3282.64C281.51 3282.64 280.964 3282.09 280.964 3281.42C280.964 3280.75 281.51 3280.2 282.183 3280.2C282.855 3280.2 283.401 3280.75 283.401 3281.42Z",
    stroke: "white",
    strokeWidth: 0.433234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20_f5",
    d: "M279.135 3283.8C279.135 3284.47 278.59 3285.02 277.917 3285.02C277.244 3285.02 276.698 3284.47 276.698 3283.8C276.698 3283.12 277.244 3282.58 277.917 3282.58C278.59 3282.58 279.135 3283.12 279.135 3283.8Z",
    stroke: "white",
    strokeWidth: 0.433234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21_f5",
    d: "M283.401 3286.17C283.401 3286.85 282.855 3287.39 282.183 3287.39C281.51 3287.39 280.964 3286.85 280.964 3286.17C280.964 3285.5 281.51 3284.95 282.183 3284.95C282.855 3284.95 283.401 3285.5 283.401 3286.17Z",
    stroke: "#4CBC18",
    strokeWidth: 0.433234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22_f5",
    d: "M280.067 3282.57L278.976 3283.19",
    stroke: "white",
    strokeWidth: 0.433234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23_f5",
    d: "M278.976 3284.4L280.067 3285.02",
    stroke: "white",
    strokeWidth: 0.433234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24_f5",
    d: "M277.917 3283.88C277.966 3283.88 278.005 3283.85 278.005 3283.8C278.005 3283.75 277.966 3283.71 277.917 3283.71C277.869 3283.71 277.829 3283.75 277.829 3283.8C277.829 3283.85 277.869 3283.88 277.917 3283.88Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.433234
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Share_f5",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.05973,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 285.848,
    y: 3285.72
  }, "Share")))), /*#__PURE__*/React.createElement("g", {
    id: "btn_6_f5"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 310.532,
    y: 3276,
    width: 50.5136,
    height: 15.5949,
    rx: 7.79747,
    fill: "#4CBC18"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Frame_3_f5",
    clipPath: "url(#clip24_11512_2147_f5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6_f5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25_f5",
    d: "M323.494 3287.37C324.084 3287.15 324.504 3286.58 324.504 3285.91V3282.96C324.504 3282.27 323.948 3281.72 323.261 3281.72H319.687C319 3281.72 318.443 3282.27 318.443 3282.96V3286.08M321.179 3280.64C320.894 3280.33 320.471 3280.13 320.013 3280.13H318.723C317.865 3280.13 317.169 3280.83 317.169 3281.69V3285.91C317.169 3286.77 317.865 3287.47 318.723 3287.47H319.562",
    stroke: "white",
    strokeWidth: 0.442014,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26_f5",
    d: "M321.46 3284.05V3287.47M322.501 3286.69L321.92 3287.28C321.671 3287.53 321.265 3287.53 321.016 3287.28L320.435 3286.69",
    stroke: "white",
    strokeWidth: 0.442014,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Download_f5",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.05973,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 326.716,
    y: 3285.72
  }, "Download"))))), /*#__PURE__*/React.createElement("g", {
    id: "4321 Oak Ave Denver, CO 80202_f5"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.5,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 288.76,
    y: 3268.05
  }, "Denver, CO 80202"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 294.261,
    y: 3258.35
  }, "4321 Oak Ave\n")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 671_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "overview_6_f5"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265.195,
    y: 3301.2,
    width: 100.875,
    height: 25.1202,
    rx: 2.9323,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 265.195,
    y: 3301.2,
    width: 100.875,
    height: 25.1202,
    rx: 2.9323,
    stroke: "#DAE4D5",
    strokeWidth: 0.390973
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 503_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 502_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_33_f5"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-370-inside-10_11512_2147_f5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.383 3307.26H288.383V3320.26H274.383V3307.26Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.383 3307.26H287.983V3320.26H288.383H288.783V3307.26H288.383Z",
    fill: "#B8C4B1",
    mask: "url(#path-370-inside-10_11512_2147_f5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 546_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Beds_2_f5",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 274.383,
    y: 3310.66
  }, "Beds"))), /*#__PURE__*/React.createElement("g", {
    id: "input_34_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "3_2_f5",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 5,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 274.383,
    y: 3318.51
  }, "3")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_35_f5"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-375-inside-11_11512_2147_f5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.383 3307.26H308.383V3320.26H294.383V3307.26Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.383 3307.26H307.983V3320.26H308.383H308.783V3307.26H308.383Z",
    fill: "#B8C4B1",
    mask: "url(#path-375-inside-11_11512_2147_f5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 546_2_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Baths_2_f5",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 294.383,
    y: 3311.16
  }, "Baths"))), /*#__PURE__*/React.createElement("g", {
    id: "input_36_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "2_2_f5",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 5,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 294.383,
    y: 3319.01
  }, "2")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_37_f5"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-380-inside-12_11512_2147_f5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.383 3307.26H332.383V3320.26H314.383V3307.26Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332.383 3307.26H331.983V3320.26H332.383H332.783V3307.26H332.383Z",
    fill: "#B8C4B1",
    mask: "url(#path-380-inside-12_11512_2147_f5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 546_3_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SF_f5",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 314.383,
    y: 3311.16
  }, "SF"))), /*#__PURE__*/React.createElement("g", {
    id: "input_38_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1,500_2_f5",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 5,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 314.383,
    y: 3319.01
  }, "1,500")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_39_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 546_4_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Year Built_2_f5",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 338.383,
    y: 3311.16
  }, "Year Built"))), /*#__PURE__*/React.createElement("g", {
    id: "input_40_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1995_f5",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 5,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 338.383,
    y: 3319.01
  }, "1995"))))))))), /*#__PURE__*/React.createElement("g", {
    id: "investment-score_2_f5"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 265.158,
    y: 3330.67,
    width: 100.949,
    height: 50.7674,
    rx: 2.37342,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 265.158,
    y: 3330.67,
    width: 100.949,
    height: 50.7674,
    rx: 2.37342,
    stroke: "#DAE4D5",
    strokeWidth: 0.316456
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_7_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ARV Estimate_2_f5",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 5.06329,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.054,
    y: 3342.41
  }, "ARV Estimate")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 437_4_f5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9_4_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$332K_2_f5",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4.11392,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 270.931,
    y: 3371.97
  }, "$332K"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 672_f5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$346K_2_f5",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 10.1266,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 300.809,
    y: 3357.25
  }, "$346K")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8_3_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 376_3_f5",
    x: 360.069,
    y: 3364,
    width: 2.5316,
    height: 89.0119,
    rx: 1.2658,
    transform: "rotate(90 360.069 3364)",
    fill: "url(#paint3_linear_11512_2147_f5)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "$360K_2_f5",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 4.11392,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 347.693,
    y: 3371.97
  }, "$360K"))))))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 793_f5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 3213,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#4F5F4A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7_f5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27_f5",
    d: "M322.616 3224.49H310.175C309.411 3224.49 308.789 3225.11 308.789 3225.87V3231.42C308.789 3232.18 309.411 3232.8 310.175 3232.8H322.616C323.38 3232.8 324.002 3232.18 324.002 3231.42V3225.87C324.002 3225.11 323.38 3224.49 322.616 3224.49ZM312.446 3229.36C312.328 3229.36 312.126 3229.37 311.937 3229.37V3230.43C311.937 3230.69 311.73 3230.89 311.475 3230.89C311.22 3230.89 311.013 3230.69 311.013 3230.43L311.006 3226.92C311.006 3226.8 311.054 3226.68 311.141 3226.59C311.228 3226.51 311.346 3226.46 311.468 3226.46H312.446C313.257 3226.46 313.918 3227.11 313.918 3227.91C313.918 3228.71 313.257 3229.36 312.446 3229.36ZM316.411 3230.78C316.136 3230.79 315.448 3230.79 315.419 3230.79C315.418 3230.79 315.418 3230.79 315.417 3230.79C315.295 3230.79 315.178 3230.74 315.092 3230.66C315.005 3230.57 314.955 3230.45 314.955 3230.33C314.955 3230.32 314.948 3226.92 314.948 3226.92C314.948 3226.8 314.996 3226.68 315.083 3226.59C315.17 3226.51 315.287 3226.46 315.41 3226.46H316.375C317.474 3226.46 318.212 3227.33 318.212 3228.62C318.212 3229.86 317.455 3230.76 316.411 3230.78ZM321.145 3228.13C321.4 3228.13 321.607 3228.34 321.607 3228.59C321.607 3228.85 321.4 3229.06 321.145 3229.06H320.307V3230.37C320.307 3230.63 320.1 3230.83 319.845 3230.83C319.589 3230.83 319.383 3230.63 319.383 3230.37V3226.89C319.383 3226.63 319.589 3226.42 319.845 3226.42H321.257C321.512 3226.42 321.719 3226.63 321.719 3226.89C321.719 3227.14 321.512 3227.35 321.257 3227.35H320.307V3228.13H321.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28_f5",
    d: "M316.373 3227.38H315.871C315.872 3227.8 315.874 3229.46 315.876 3229.86C316.068 3229.86 316.274 3229.86 316.393 3229.86C317.011 3229.85 317.287 3229.23 317.287 3228.62C317.287 3228.33 317.221 3227.38 316.373 3227.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29_f5",
    d: "M312.444 3227.38H311.93C311.93 3227.59 311.931 3227.81 311.931 3227.91C311.931 3228.03 311.932 3228.25 311.933 3228.44C312.122 3228.44 312.325 3228.44 312.444 3228.44C312.741 3228.44 312.992 3228.2 312.992 3227.91C312.992 3227.62 312.741 3227.38 312.444 3227.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30_f5",
    d: "M322.139 3223.56C322.032 3223.27 321.866 3223 321.646 3222.77L319.727 3220.74C319.293 3220.29 318.682 3220.02 318.051 3220.02H311.901C311.137 3220.02 310.516 3220.65 310.516 3221.41V3223.56H322.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31_f5",
    d: "M310.516 3233.73V3234.4C310.516 3235.17 311.137 3235.79 311.901 3235.79H320.894C321.658 3235.79 322.279 3235.17 322.279 3234.4V3233.73H310.516Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature-5.f7db0b755aabdac76f19ab0a44475e4a.svg";
export { ForwardRef as ReactComponent };